export const LOAD_FACILITY_TYPES_REQUEST = 'LOAD_FACILITY_TYPES_REQUEST';
export const LOAD_FACILITY_TYPES_SUCCESS = 'LOAD_FACILITY_TYPES_SUCCESS';
export const SEARCH_SET_FILTER_FACILITY_TYPE = 'SEARCH_SET_FILTER_FACILITY_TYPE';
export const SEARCH_REMOVE_FILTER_FACILITY_TYPE = 'SEARCH_REMOVE_FILTER_FACILITY_TYPE';